import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './Countdown.css';
import { ClockCircleOutlined } from '@ant-design/icons';

const Countdown = ({ date }) => {
  const [now, setNow] = React.useState(Date.now());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const mDate = moment(date);
  if (!mDate.isValid()) {
    return null;
  }

  // Use total seconds to avoid Moment's residual day unit (e.g. "6 days" of a month remainder).
  const totalSeconds = Math.max(0, Math.floor(mDate.diff(now) / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return (
    <div className="Countdown">
      <ClockCircleOutlined className="clock-icon" />
      <div>
        <span className="value">{days}</span>
        <span>días</span>
      </div>
      <div>
        <span className="value">{hours}</span>
        <span>horas</span>
      </div>
      <div>
        <span className="value">{minutes}</span>
        <span>minutos</span>
      </div>
      <div>
        <span className="value">{seconds}</span>
        <span>segundos</span>
      </div>
    </div>
  );
};

Countdown.propTypes = {
  date: PropTypes.string,
};

Countdown.defaultProps = {
  date: '',
};

Countdown.displayName = 'Countdown';

export default Countdown;
